import { useState } from 'react'
import RegularButton from './RegularButton'
import { data } from '../data/data'

function selectionKey(category, pairs) {
  return `${category}:${pairs}`
}

export default function Form({
  handleSubmit,
  defaultCategory = 'flags',
  defaultPairs = 4,
  status = 'idle',
  gameStats = { last: null, bestByKey: {} },
}) {
  const [category, setCategory] = useState(defaultCategory)
  const [pairs, setPairs] = useState(defaultPairs)

  function onSubmit(e) {
    e.preventDefault()
    handleSubmit({ category, pairs })
  }

  const key = selectionKey(category, pairs)
  const last = gameStats.last
  const lastForSelection =
    last && last.category === category && last.pairs === pairs ? last : null
  const best = gameStats.bestByKey?.[key]

  const lastLabel =
    lastForSelection != null
      ? `${lastForSelection.moves} moves`
      : 'No games yet'
  const bestLabel =
    best != null ? `${best.moves} moves` : 'No best yet'

  const ctaLabel =
    status === 'loading' ? 'Loading…' : 'Play now'

  return (
    <form className="start-panel wrapper wrapper--accent" onSubmit={onSubmit}>
      <header className="start-panel__hero">
        <h1>Memory Match</h1>
        <p className="start-panel__lead">
          Flip cards and find every pair — fewer moves is better.
        </p>
      </header>

      <div className="start-panel__preview" aria-hidden="true">
        <span className="preview-card preview-card--back">❓</span>
        <span className="preview-card preview-card--flag">
          <span className="fi fi-gb" />
        </span>
        <span className="preview-card preview-card--back">❓</span>
        <span className="preview-card preview-card--flag">
          <span className="fi fi-jp" />
        </span>
      </div>

      <div className="start-panel__settings">
        <div className="setting-row">
          <div className="setting-row__field">
            <label htmlFor="category">
              <span className="setting-label__mark" aria-hidden="true">
                🎴
              </span>
              <span>Category</span>
            </label>
            <select
              id="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {data.category.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="setting-row">
          <div className="setting-row__field">
            <label htmlFor="pairs">
              <span className="setting-label__mark" aria-hidden="true">
                🎯
              </span>
              <span>Difficulty</span>
            </label>
            <select
              id="pairs"
              value={pairs}
              onChange={(e) => setPairs(Number(e.target.value))}
            >
              {data.pairs.map((p) => (
                <option key={p.value} value={p.value}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="start-panel__stats">
        <div className="stat-block">
          <p className="stat-block__label">Last result</p>
          <p
            className={
              lastForSelection != null
                ? 'stat-block__value'
                : 'stat-block__value stat-block__value--placeholder'
            }
          >
            {lastLabel}
          </p>
        </div>
        <div className="stat-block">
          <p className="stat-block__label">Best score</p>
          <p
            className={
              best != null
                ? 'stat-block__value'
                : 'stat-block__value stat-block__value--placeholder'
            }
          >
            {bestLabel}
          </p>
        </div>
      </div>

      <RegularButton handleClick={onSubmit} variant="cta">
        {ctaLabel}
      </RegularButton>
    </form>
  )
}
